import { User } from 'oidc-client';
import { CallbackComponent, createUserManager } from 'redux-oidc';
import { useGetTenantQuery } from '../../redux/api/BaseApi';
import { oAuthSettings } from './AuthSettings';

const CallbackPage = () => {
    console.log('CallbackPage');
    const { data: tenant, isFetching, error } = useGetTenantQuery();
    let settings = oAuthSettings;
    if (tenant?.Authority)
        settings.authority = tenant?.Authority

    const successCallback = (user: User) => {
        console.log('successCallback', user);
        window.location.href = user.state ? user.state : "./";
        //window.location.href = "./";
    };
    const authManager = createUserManager(settings);
    const errorCallback = (error) => {
        console.error('errorCallback', error);
        //try re-authenticate
        authManager.signinRedirect();
    };
    if (!error && (isFetching || tenant == null)) {
        console.error('Error in useGetTenantQuery, BLANK', settings);
        return <></>
    } else {
        //console.log('settings ready')
    }

    console.log('CallbackPage authManager', authManager);
    return (
        <CallbackComponent userManager={authManager} successCallback={successCallback} errorCallback={errorCallback} >
            <></>
        </CallbackComponent>
    )
}

export default CallbackPage;